import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { getValidSitecoreLink } from 'components/SitecoreLink';
import type { DigizuiteAsset } from 'models/asset';
import type { Field, SitecoreBlockProps, SitecoreLink } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';
import { getAsset } from 'utils/helpers';

import TeaserCarousel from './TeaserCarousel';

interface Item {
	campaignBubbleLabel?: Field<string>;
	campaignBubbleSale?: Field<boolean>;
	campaignBubbleText?: Field<string>;
	heading?: Field<string>;
	link?: Field<SitecoreLink>;
	squareImage?: Field<DigizuiteAsset[]>;
}

interface Props extends SitecoreBlockProps {
	fields?: {
		heading?: Field<string>;
		items?: Item[];
	};
}

export default function TeaserCarouselBlock({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const items = filterTruthy(
		(fields.items ?? []).map((item) => {
			const image = getAsset('Templated 1:1', item.squareImage);
			return {
				campaignBubbleLabel: item.campaignBubbleLabel?.value,
				campaignBubbleSale: Boolean(item.campaignBubbleSale?.value),
				campaignBubbleText: item.campaignBubbleText?.value,
				heading: item.heading,
				imageAlt: image?.alt,
				imageSrc: image?.src,
				link: getValidSitecoreLink(item.link?.value),
			};
		}),
		'link',
		'imageSrc',
	);

	if (items.length === 0) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="TeaserCarousel"
				description="Requires at least one item with a heading, link and image"
			/>
		);
	}

	return (
		<TeaserCarousel
			className={getEditorMargin(params)}
			heading={fields.heading}
			headingLevel={params?.heading}
			id={params?.anchor}
			items={items}
		/>
	);
}
TeaserCarouselBlock.displayName = 'TeaserCarouselBlock';
